// extracted by mini-css-extract-plugin
export var active = "_ec-2";
export var recordingDot = "_ec-1";
export var recordingIndicator = "_ec-0";